import skierBase from '@/assets/images/not-found/skier-base.jpg';
import skierMaskUrl from '@/assets/images/not-found/skier-mask.svg?url';
import skierOverlay from '@/assets/images/not-found/skier-overlay.png';
import { Button } from '@/components/Button';
import { useNavigate } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

function SkierIllustration() {
  const maskStyle = {
    WebkitMaskImage: `url(${skierMaskUrl})`,
    maskImage: `url(${skierMaskUrl})`,
  } as const;

  return (
    <div className={styles.skierIllustration}>
      <div className={styles.skierStack}>
        <div className={styles.skierMasked} style={maskStyle}>
          <img className={styles.skierPhoto} src={skierBase} alt="" />
          <div className={styles.skierFade} aria-hidden />
        </div>
        <div className={styles.skierOverlay}>
          <img src={skierOverlay} alt="" />
        </div>
      </div>
    </div>
  );
}

export const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      void navigate(-1);
      return;
    }
    void navigate('/');
  };

  return (
    <main className={styles.root}>
      <div className={styles.center}>
        <SkierIllustration />
        <div className={styles.copy}>
          <h1 className={styles.title}>Page not found</h1>
          <p className={styles.subtitle}>
            Looks like the page you&apos;re looking for got lost somewhere
          </p>
        </div>
        <div className={styles.actions}>
          <Button
            className={styles.actionBtn}
            type="button"
            variant="solid"
            size="large"
            onClick={() => void navigate('/')}
          >
            Go home
          </Button>
          <Button
            className={styles.actionBtn}
            type="button"
            variant="subtle"
            size="large"
            onClick={handleBack}
          >
            Back
          </Button>
        </div>
      </div>
    </main>
  );
};
